const DiiaIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M512 1024C736.36 1024 861.082 1024 942.541 942.541C1024 861.082 1024 736.434 1024 512C1024 287.566 1024 162.918 942.541 81.4588C861.082 0 736.36 0 512 0C287.64 0 162.918 0 81.4588 81.4588C0 162.918 0 287.64 0 512C0 736.36 0 861.082 81.4588 942.541C162.918 1024 287.64 1024 512 1024Z"
      fill="black"
    />
    <path
      d="M704.294 410.767C665.617 410.767 636.91 440.624 636.91 477.464C636.91 507.544 658.06 531.014 684.835 537.959L629.947 622.036H681.214L727.876 543.789H762.803V622.036H805.603V410.767H704.294ZM710.181 508.046C692.578 508.046 681.678 494.231 681.678 478.485C681.678 462.739 691.668 447.736 710.181 447.736H762.859V508.046H710.181Z"
      fill="white"
    />
    <path
      d="M469.904 410.767L455.699 449.871L513.985 449.537L479.467 576.135C469.625 613.049 508.099 640.938 540.928 619.232L615.59 568.578L593.606 536.269L519.036 587.926L569.3 410.767H469.904Z"
      fill="white"
    />
    <path
      d="M550.289 383.601C566.645 383.601 579.905 371.655 579.905 356.919C579.905 342.183 566.645 330.236 550.289 330.236C533.932 330.236 520.672 342.183 520.672 356.919C520.672 371.655 533.932 383.601 550.289 383.601Z"
      fill="white"
    />
    <path
      d="M399.216 583.039V361.669H234.981V479.819C234.981 535.412 218.882 569.782 209.394 582.946H189.934V679.501H231.583V622.422H387.296V679.594H428.926V583.039H399.216ZM276.388 477.386V400.941H356.51V582.909H253.085C262.462 567.572 276.388 528.542 276.388 477.386Z"
      fill="white"
    />
  </svg>
);
export default DiiaIcon;
